import moment from "moment";
import {
  getAuth,
  onAuthStateChanged,
  signOut,
  fetchSignInMethodsForEmail,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";
import { TYPES } from "./user_auth.type";
import { DATABASE_URL, SOURCE } from "config/config";
import {
  getDatabase,
  ref,
  set,
  onDisconnect,
  serverTimestamp,
} from "firebase/database";
import { getApiFunctions } from "../api";
import { getApp } from "firebase/app";
import { PROJECT_ID } from "config/keys/user";
import { convertVnTime } from "util/time.function";

const app = getApp(PROJECT_ID);
const auth = getAuth(app);
const db = getDatabase(app, DATABASE_URL);

// -------------------------- Snapshot --------------------------
const authSub = [];
export const snapUserAuth = () => (dispatch) => {
  const unSub = onAuthStateChanged(auth, async (user) => {
    const uid = user?.uid;
    const isLogged = uid ? true : false;
    const time = moment().toISOString();
    const current = `auth-user:${JSON.stringify(isLogged)}-(${time})`;
    console.log(current);
    const reloadUserInfo = user?.reloadUserInfo;
    const email = user?.email;
    const permissions = reloadUserInfo?.customAttributes;
    const lastRefreshAt = reloadUserInfo?.lastRefreshAt;
    const lastRefresh = convertVnTime(lastRefreshAt);
    const userp = { permissions, lastRefresh };
    console.log({ userp });

    firebasePermissionSuccess(dispatch, permissions);
    firebaseEmailSuccess(dispatch, email);
    firebaseAuthSuccess(dispatch, isLogged);
    firebaseUidSuccess(dispatch, uid);

    if (user) {
      monitorOnline(user);
    }
  });
  authSub.push(unSub);
};

const monitorOnline = (user) => {
  const uid = user?.uid;
  const userRef = ref(db, `/user/${uid}`);

  set(userRef, {
    isOnline: true,
    updateAt: serverTimestamp(),
    // Bạn có thể thêm các thông tin khác ở đây nếu cần
  }).then(() => {
    // Thiết lập trạng thái offline khi ngắt kết nối
    onDisconnect(userRef).update({
      isOnline: false,
      updateAt: serverTimestamp(),
    });
  });
};

export const unSnapUserAuth = () => (dispatch) => {
  authSub.forEach((subscriber) => {
    subscriber();
  });
  authSub.length = 0;
};

export const logOut = () => (dispatch) => {
  signOut(auth);
};

export const checkEmail =
  ({ register }, callback) =>
  (dispatch) => {
    const email = register.email;
    console.log({ email });
    return fetchSignInMethodsForEmail(auth, email)
      .then((response) => {
        console.log({ response });
        if (response.length === 0) {
          if (callback) {
            callback({
              status: 200,
            });
          }
          firebaseRegisterSuccess(dispatch, register);
        } else {
          callback({
            status: 500,
            data: "Email này đã được sử dụng, xin vui lòng đăng ký email khác",
          });
        }
      })
      .catch((error) => console.log({ error }));
  };

export const registerEmailPassword =
  ({ register }, callback) =>
  (dispatch) => {
    const email = register.email;
    const password = register.password;
    createUserWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        if (callback) {
          callback({
            status: 200,
            data: user,
          });
        }
      })
      .catch((error) => {
        const code = error?.code;
        console.log({ code });
        if (code === "auth/email-already-in-use") {
          callback &&
            callback({
              status: 500,
              data: "Email này đã được sử dụng, xin vui lòng đăng ký email khác",
            });
        } else {
          callback &&
            callback({
              status: 500,
              data: error.code,
            });
        }
      });
  };

// EXTRA KHUONG's FUNC
export const forgetPassword =
  ({ email }, callback) =>
  (dispatch) => {
    console.log({ email });
    sendPasswordResetEmail(auth, email)
      .then(() => {
        if (callback) {
          callback({
            status: 200,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        if (callback) {
          callback({
            status: 500,
            data: error.code,
          });
        }
      });
  };
// ================ CLOUD FUNCTIONS ==================== //

export const sendEmail =
  ({ email }, callback) =>
  (dispatch) => {
    const apiEmailVerify = getApiFunctions().email.emailSendCode;
    apiEmailVerify({ email, source: SOURCE })
      .then((response) => {
        console.log({ response });
        const data = response.data;
        const lastSent = moment().toDate();
        firebaseGetLastMailSuccess(dispatch, lastSent);
        if (callback) {
          callback({ status: 200, data });
        }
      })
      .catch((err) => {
        console.log({ err });
        callback({ status: 500, data: err?.message || "Invalid Error" });
      });
  };

export const verifyEmail =
  ({ email, pincode }, callback) =>
  (dispatch) => {
    const apiEmailVerify = getApiFunctions().email.emailCheckCode;
    apiEmailVerify({ email, pincode, source: SOURCE })
      .then((response) => {
        const data = response.data;
        if (callback) {
          callback({ status: 200, data });
        }
      })
      .catch((err) => {
        console.log({ err });
        callback({ status: 500, data: err?.message || "Invalid Error" });
      });
  };

export const setStepRegister = (step) => (dispatch) => {
  setRegisterStepSuccess(dispatch, step);
};

// -------------------------- Dispatch --------------------------
const firebaseAuthSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.FIREBASE_AUTH_STATUS,
    payload: data,
  });
};

const firebaseUidSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.FIREBASE_AUTH_UID,
    payload: data,
  });
};

const firebasePermissionSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.FIREBASE_AUTH_PERMISSIONS,
    payload: data,
  });
};

const firebaseRegisterSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.FIREBASE_AUTH_REGISTER_SUCCESS,
    payload: data,
  });
};

const setRegisterStepSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.FIREBASE_AUTH_REGISTER_STEP,
    payload: data,
  });
};

const firebaseGetLastMailSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.FIREBASE_AUTH_REGISTER_LASTMAIL,
    payload: data,
  });
};

const firebaseEmailSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.FIREBASE_AUTH_EMAIL,
    payload: data,
  });
};

const setForgetDialogOpenSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_FORGET_DIALOG_OPEN,
    payload: data,
  });
};
